import { useState } from 'react';
import axios from 'axios';
import { urls } from '../services/apiService';

const useProcessData = () => {
  const [dataLoading, setDataLoading] = useState(false);
  const [dataError, setDataError] = useState(null);
  const [response, setResponse] = useState(null);
  const [resultStatus, setResultStatus] = useState(null);

  const processData = async (deviceId, dates) => {
    setDataLoading(true);
    setDataError(null);
    setResponse(null);
    setResultStatus(null); // Reset resultStatus at the start

    try {
      const result = await axios.post(
        urls.process_data,
        { device_id: deviceId, date: dates },
        { headers: { 'Content-Type': 'application/json' } }
      );
      // Set the response and status for successful requests
      setResponse(result.data);
      setResultStatus(result.status);
    } catch (err) {
      // Handle errors and set the appropriate status
      if (err.response) {
        // The request was made and the server responded with a status code
        setDataError(err.response.data);
        setResultStatus(err.response.status);
      } else if (err.request) {
        // The request was made but no response was received
        setDataError('No response received from the server');
        setResultStatus(500); // Use a generic server error status
      } else {
        // Something happened in setting up the request
        setDataError(err.message);
        setResultStatus(500); // Use a generic server error status
      }
    } finally {
      setDataLoading(false);
    }
  };

  return { processData, dataLoading, dataError, response, resultStatus };
};

export default useProcessData;